"use client";
import Button from "@/components/Button/Button.component";
import Card from "@/components/Card/Card.component";
import { CardPropsModel } from "@/components/Card/Card.model";
import { Typography } from "@/components/Typography/Typography.component";
import { cn } from "@/lib/utils";
import { useState } from "react";
import { BUTTON_SUBTYPE_CLASS } from "../Button/Button.model";
import { CardLayoutPropsModel } from "./CardLayout.model";

const CardLayout = ({
  title,
  featuredCaseStudiesCollection: cards,
  link,
}: CardLayoutPropsModel) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  const calcColSpan = (index: number) => {
    let colSpan = 2;

    switch (cards.length) {
      case 4:
        colSpan = index === 0 ? 6 : 2;
        break;
      case 5:
        colSpan = index < 2 ? 3 : 2;
        break;
      default:
        break;
    }
    return `col-span-${colSpan}`;
  };

  const changeCardHoverStatus = (val: boolean) => {
    setIsHovered(val);
  };

  return (
    <div className="bg-core-white px-sm md:px-md lg:px-lg pb-20">
      <Typography.H5 className="pt-10 pb-20 text-(size:--font-size-h6)">
        {title}
      </Typography.H5>
      <div
        className={cn(
          "grid gap-12 md:grid-cols-6 md:gap-x-10 md:gap-y-16",
          cards.length < 4 && `md:grid-cols-${cards.length * 2}`,
        )}
      >
        {cards.map((card: CardPropsModel, index: number) => (
          <div className={`md:${calcColSpan(index)}`} key={index}>
            <Card
              brand={card?.brand}
              name={card?.name}
              thumbnail={card?.thumbnail}
              isHovered={isHovered}
              slug={`/work/${card?.slug}`}
              changeCardHoverStatus={changeCardHoverStatus}
            />
          </div>
        ))}
      </div>
      {link && (
        <div className="pt-lg hidden justify-end md:grid">
          <Button
            primary={false}
            type={BUTTON_SUBTYPE_CLASS.SECONDARY_BLACK}
            content={{ ...link }}
          />
        </div>
      )}
    </div>
  );
};

export default CardLayout;
